import { handleActions, combineActions } from 'redux-actions'

import { newSearch } from '@/results/store/actions'
import { job } from '@/search/store/actions'

export default handleActions({
  [combineActions(newSearch.request, job.setSelectedId)]: () => []
}, [])
